import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
    {
        q: "Who do you serve?",
        a: "Crossroads to Change Residential Treatment Center serves male youth in Texas foster care who need a safe, structured, and therapeutic environment to stabilize and grow. Admissions are reviewed case-by-case to ensure we can meet each youth's needs.",
    },
    {
        q: "Is this a treatment center?",
        a: "Yes. We are a trauma-informed residential treatment center providing 24/7 supervision, therapeutic support, education coordination, and relationship-based care using a TBRI-informed approach.",
    },
    {
        q: "How does the referral process work?",
        a: "Our 4-step process: (1) Submit referral information, (2) Initial review by our admissions team, (3) Provide required documents (clinical, medical, education, placement/DFPS), (4) Admissions decision. See the Referrals page for the full document checklist.",
    },
    {
        q: "What clinical services are provided?",
        a: "We provide access to individual therapy, group support, psychiatric care coordination, medication monitoring, and crisis stabilization support — alongside daily structure, life skills development, and education coordination.",
    },
    {
        q: "What is TBRI?",
        a: "TBRI® (Trust-Based Relational Intervention) is a trauma-informed, attachment-based care model. Our staff use it to prioritize connection, safety, correction, and consistency — recognizing that behavior is communication, especially for youth who have experienced trauma.",
    },
    {
        q: "How can I refer a youth?",
        a: "Caseworkers, DFPS partners, courts, and caregivers can submit referrals through our Referrals page, call us at 281.547.8447, or email info@crossroadstochange.com. Our team responds within one business day.",
    },
    {
        q: "Do you work with DFPS and the courts?",
        a: "Yes — we partner closely with DFPS, courts, caseworkers, caregivers, and education teams to coordinate care, share progress, and keep each youth's plan moving forward.",
    },
];

export default function FAQSection() {
    return (
        <section className="py-20 md:py-24 bg-[#F7F5F0]">
            <div className="max-w-4xl mx-auto px-6">
                <div className="mb-10">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Frequently asked questions
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight">
                        Answers, in plain language.
                    </h2>
                </div>
                <div className="bg-white rounded-3xl border border-[#E5DFD3] p-3 md:p-6">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQ.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                className="border-b border-[#E5DFD3] last:border-0"
                            >
                                <AccordionTrigger
                                    className="text-left font-[Outfit] text-[16.5px] font-medium text-[#1A2230] hover:no-underline px-3 py-5"
                                    data-testid={`faq-q-${i}`}
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    className="text-[15px] leading-relaxed text-[#6F6B63] px-3 pb-5"
                                    data-testid={`faq-a-${i}`}
                                >
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
